import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { salesAPI } from '../../../api/salesAPI';
import { useState, useEffect } from 'react';
import Spinner from '../../../components/spinner/spinner';
import './comparison_sales.css';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function SalesComparisons() {
    const [salesData, setSalesData] = useState({
        todaySales: [],
        yesterdaySales: [],
        currentWeekSales: [],
        lastWeekSales: [],
        currentMonthSales: [],
        lastMonthSales: []
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSalesData = async () => {
            try {
                const response = await salesAPI.getSalesComparison();
                setSalesData({
                    todaySales: response.todaySales,
                    yesterdaySales: response.yesterdaySales,
                    currentWeekSales: response.currentWeekSales,
                    lastWeekSales: response.lastWeekSales,
                    currentMonthSales: response.currentMonthSales,
                    lastMonthSales: response.lastMonthSales,
                });
                setLoading(false);
            } catch (error) {
                console.error("Error fetching sales data:", error);
                setLoading(false);
            }
        };

        fetchSalesData();
    }, []);

    if (loading) {
        return (
            <div className="loading-container">
                <Spinner />
                <div>Loading....</div>
            </div>
        );
    }

    // Chart Labels
    const categories = ['Yesterday vs Today', 'Last Week vs Current Week', 'Last Month vs Current Month'];

    const chartData = {
        labels: categories,
        datasets: [
            {
                label: "Previous Period",
                data: [
                    salesData.yesterdaySales.reduce((a, b) => a + b, 0),
                    salesData.lastWeekSales.reduce((a, b) => a + b, 0),
                    salesData.lastMonthSales.reduce((a, b) => a + b, 0)
                ],
                backgroundColor: 'rgba(59, 130, 246, 0.7)',
                borderColor: 'rgba(59, 130, 246, 1)',
                borderWidth: 1
            },
            {
                label: "Current Period",
                data: [
                    salesData.todaySales.reduce((a, b) => a + b, 0),
                    salesData.currentWeekSales.reduce((a, b) => a + b, 0),
                    salesData.currentMonthSales.reduce((a, b) => a + b, 0)
                ],
                backgroundColor: 'rgba(252, 186, 3, 0.7)',
                borderColor: 'rgba(252, 186, 3, 1)',
                borderWidth: 1
            }
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    color: 'white',
                },
            },
        },
        scales: {
            x: {
                ticks: { color: 'white' }, // X-axis labels color
                grid: { color: 'rgba(255, 255, 255, 0.2)' }, // Grid color
            },
            y: {
                ticks: { color: 'white' }, // Y-axis labels color
                grid: { color: 'rgba(255, 255, 255, 0.2)' }, // Grid color
            },
        },
    };

    return (
        <div className="container" style={{ backgroundColor: '#1E293B' }}>
            <div className='row'>
                <div className='col-xs-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                <div className='col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 form__body_graph'>
                    <h6 className='text-center sales_comparisons'>Sales Comparison</h6>
                    <div className='sales_chart'>
                        <Bar data={chartData} options={chartOptions} />
                    </div>
                </div>
                <div className='col-xs-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
            </div>
        </div>
    );
}
